
// 工具类：为指定 root 下所有 model-viewer 注入自定义加载圈（覆盖默认进度条）
class DlModelViewerHelper {
	static initSpinner(root = document) {
		const viewers = root.querySelectorAll && root.querySelectorAll('model-viewer');
		if (!viewers || !viewers.length) return;
		viewers.forEach((mv) => {
			if (mv.querySelector('[slot="progress-bar"].loading__spinner')) return;
			const loader = document.createElement('div');
			loader.className = 'loading__spinner';
			loader.setAttribute('slot', 'progress-bar');
			loader.innerHTML = `
				<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
				</svg>
			`;
			mv.appendChild(loader);

			// 防止加载圈阻挡交互
			loader.style.pointerEvents = 'none';

			const show = () => loader.classList.remove('hidden');
			const hide = () => loader.classList.add('hidden');
			show();
			mv.addEventListener('progress', (e) => {
				const p = (e.detail && typeof e.detail.totalProgress === 'number') ? e.detail.totalProgress : 0;
				if (p >= 1) hide();
				else show();
			});
			mv.addEventListener('load', hide);
			mv.addEventListener('presenting', hide);
			mv.addEventListener('model-visibility', (ev) => {
				if (ev.detail && ev.detail.visible) hide();
			});

			// // ✅ 阻止 Glide 捕获 model-viewer 拖动（保持模型交互）
			// mv.addEventListener('pointerdown', e => e.stopPropagation());
			// mv.addEventListener('mousedown', e => e.stopPropagation());
			// mv.addEventListener('touchstart', e => e.stopPropagation());
		});
	}
}

class DlProductGalleryX extends HTMLElement {
	constructor() {
		super();
		this.variantGalleries = Array.from(this.querySelectorAll('.dl-product-gallery-x-container'));
		this.lastWindowWidth = window.innerWidth;
		this.currentBreakpoint = this.getCurrentBreakpoint();
		this.currentVariantId = this.dataset.currentVariantId || '';
		this.productH = this.closest('dl-product-h');
		this.addtoCartBar = this.productH?.querySelector('dl-product-addtocart-v2');
		this.currentArButtonState = 'normal';
		this.bindEvents();
		this.hydrateVisibleGallery();
		this.observeShortContentLayout();
		this.initializeAllGalleries();
		requestAnimationFrame(() => this.checkSeeFullGalleryVisibility());
	}

	getCurrentBreakpoint() {
		return window.innerWidth <= 990 ? 'mobile' : 'desktop';
	}

	getVisibleGallery() {
		return this.variantGalleries.find(gallery => !gallery.classList.contains('dl-hide'));
	}

	getFloatingButtons() {
		const visibleGallery = this.getVisibleGallery();
		if (!visibleGallery) return [];
		return [
			visibleGallery.querySelector('.dl-product-gallery-ar-pop-x-enter'),
			visibleGallery.querySelector('.dl-product-gallery-app-demo-pop-m-enter')
		].filter(Boolean);
	}

	observeShortContentLayout() {
		this.updateShortContentLayout();
		if (typeof ResizeObserver === 'undefined') return;

		this.layoutObserver ||= new ResizeObserver(() => {
			if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
			this.layoutFrame = requestAnimationFrame(() => {
				this.updateShortContentLayout();
				this.isReachBottom();
				this.updateArButtonPosition();
			});
		});
		this.layoutObserver.disconnect();
		const section = this.closest('.dl-product-h');
		[
			section?.querySelector('dl-pdp-promo-banner:not(.is-m-only)'),
			section?.querySelector('.dl-product-info-h-heading'),
			section?.querySelector('.dl-product-h-main-container'),
			...this.querySelectorAll('.dl-product-gallery-x-desktop')
		].filter(Boolean).forEach(element => this.layoutObserver.observe(element));
	}

	updateShortContentLayout() {
		const section = this.closest('.dl-product-h');
		const info = section?.querySelector('.dl-product-h-main');
		const infoContent = info?.querySelector('.dl-product-h-main-container');
		const gallery = this.getVisibleGallery()?.querySelector('.dl-product-gallery-x-desktop');
		if (!section || !info || !infoContent || !gallery || window.innerWidth <= 990) {
			this.classList.remove('dl-gallery-taller-than-info');
			section?.classList.remove('dl-gallery-taller-than-info');
			section?.style.removeProperty('--dl-short-promo-height');
			section?.style.removeProperty('--dl-short-heading-height');
			section?.style.removeProperty('--dl-short-main-height');
			this.isShortContentGallery = false;
			return;
		}

		const infoStyle = getComputedStyle(info);
		const heading = section.querySelector('.dl-product-info-h-heading');
		const promo = section.querySelector('dl-pdp-promo-banner:not(.is-m-only)');
		const headingHeight = heading?.getBoundingClientRect().height || 0;
		const promoHeight = promo?.getBoundingClientRect().height || 0;
		const mainHeight = infoContent.getBoundingClientRect().height
			+ parseFloat(infoStyle.paddingTop || 0)
			+ parseFloat(infoStyle.paddingBottom || 0);
		const infoHeight = mainHeight + headingHeight + promoHeight;
		const galleryHeight = gallery.scrollHeight;
		const isShort = infoHeight < window.innerHeight && galleryHeight > infoHeight + 1;
		this.isShortContentGallery = isShort;
		this.classList.toggle('dl-gallery-taller-than-info', isShort);
		section.classList.toggle('dl-gallery-taller-than-info', isShort);
		if (isShort) {
			section.style.setProperty('--dl-short-promo-height', `${promoHeight}px`);
			section.style.setProperty('--dl-short-heading-height', `${headingHeight}px`);
			section.style.setProperty('--dl-short-main-height', `${mainHeight}px`);
		} else {
			section.style.removeProperty('--dl-short-promo-height');
			section.style.removeProperty('--dl-short-heading-height');
			section.style.removeProperty('--dl-short-main-height');
		}
		if (isShort) this.classList.remove('dl-scroll', 'dl-fixed', 'dl-reach-bottom');
	}

	hydrateGallery(gallery, breakpoint = this.getCurrentBreakpoint()) {
		if (!gallery) return;
		const template = gallery.querySelector(`template[data-dl-gallery-template="${breakpoint}"]`);
		if (!template) return;
		gallery.appendChild(template.content.cloneNode(true));
		template.remove();
	}

	hydrateVisibleGallery() {
		const visibleGallery = this.getVisibleGallery();
		this.hydrateGallery(visibleGallery);
	}

	initializeGallery(gallery, breakpoint = this.getCurrentBreakpoint()) {
		if (!gallery) return;
		const mountedSelector = breakpoint === 'mobile'
			? '.dl-product-gallery-x-mobile'
			: '.dl-product-gallery-x-desktop';
		if (!gallery.querySelector(mountedSelector)) return;

		const flag = breakpoint === 'mobile' ? '_dlMobileGalleryReady' : '_dlDesktopGalleryReady';
		if (gallery[flag]) return;

		if (breakpoint === 'mobile') {
			if (typeof Glide === 'undefined') return;
			this.initGlide(gallery);
		}
		this.initCustomVideoControls(gallery);
		this.initGalleryVideoAutoplay(gallery, breakpoint);
		DlModelViewerHelper.initSpinner(gallery);
		gallery[flag] = true;
	}

	static toggle(variantId) {
		document.querySelectorAll('dl-product-gallery-x').forEach(galleryX => {
			galleryX.toggleVariant(variantId);
		});
	}

	toggleVariant(variantId) {
		let found = false;
		this.currentVariantId = String(variantId);
		this.dataset.currentVariantId = this.currentVariantId;
		this.variantGalleries.forEach(gallery => {
			// 支持单个ID或逗号分隔的多个ID
			const variantIds = gallery.dataset.dlVariantId.split(',').map(id => id.trim());
			const match = variantIds.includes(String(variantId));
			if (match) {
				found = true;
				this.hydrateGallery(gallery);
				this.initializeGallery(gallery);
				gallery.classList.remove('dl-hide');
				const glide = gallery.glideInstance;
				if (glide) {
					glide.index = 0;
					glide.update();
					this.updateCounter(gallery);
				}
				// 切换首图显示
				this.toggleFeaturedImage(gallery, variantId);
			} else {
				gallery.classList.add('dl-hide');
			}
		});
		if (!found) console.warn('⚠️ 未找到变体画廊:', variantId);
		this.currentArButtonState = null;
		this.observeShortContentLayout();
		this.isReachBottom();
		this.updateArButtonPosition();
		requestAnimationFrame(() => this.checkSeeFullGalleryVisibility());
	}

	toggleFeaturedImage(gallery, variantId) {
		// 查找首图容器（桌面端、移动端、桌面端弹窗、移动端弹窗）
		const desktopFirstItem = gallery.querySelector('.dl-product-gallery-x-desktop-gallery-first-item');
		const mobileFirstItem = gallery.querySelector('.dl-product-gallery-x-main-first-item');
		const popupFirstItem = gallery.querySelector('.dl-product-gallery-pop-x-media-first-item');
		const popupMobileFirstItem = gallery.querySelector('.dl-product-gallery-pop-x-media-first-item-mobile');
		
		// 处理桌面端首图切换
		if (desktopFirstItem) {
			const featuredImages = desktopFirstItem.querySelectorAll('.dl-variant-featured-image');
			if (featuredImages.length) {
				featuredImages.forEach(img => img.classList.remove('dl-show'));
				const targetImage = desktopFirstItem.querySelector(`.dl-variant-featured-image[data-dl-variant-id="${variantId}"]`);
				if (targetImage) {
					targetImage.classList.add('dl-show');
				}
			}
		}

		// 处理移动端首图切换
		if (mobileFirstItem) {
			const featuredImages = mobileFirstItem.querySelectorAll('.dl-variant-featured-image');
			if (featuredImages.length) {
				featuredImages.forEach(img => img.classList.remove('dl-show'));
				const targetImage = mobileFirstItem.querySelector(`.dl-variant-featured-image[data-dl-variant-id="${variantId}"]`);
				if (targetImage) {
					targetImage.classList.add('dl-show');
				}
			}
		}

		// 处理桌面端弹窗首图切换（仅在无3D模型时）
		if (popupFirstItem) {
			const featuredItems = popupFirstItem.querySelectorAll('.dl-variant-featured-item');
			if (featuredItems.length) {
				featuredItems.forEach(item => item.classList.remove('dl-show'));
				const targetItem = popupFirstItem.querySelector(`.dl-variant-featured-item[data-dl-variant-id="${variantId}"]`);
				if (targetItem) {
					targetItem.classList.add('dl-show');
				}
				
				// 同时更新缩略图中的第一个缩略图（变体首图的缩略图）
				// 注意：如果有3D模型，不需要更新缩略图
				this.updatePopupFirstThumbnail(gallery, variantId);
			}
		}

		// 处理移动端弹窗首图切换（始终切换变体首图，不受3D模型影响）
		if (popupMobileFirstItem) {
			const featuredItems = popupMobileFirstItem.querySelectorAll('.dl-variant-featured-item-mobile');
			if (featuredItems.length) {
				featuredItems.forEach(item => item.classList.remove('dl-show'));
				const targetItem = popupMobileFirstItem.querySelector(`.dl-variant-featured-item-mobile[data-dl-variant-id="${variantId}"]`);
				if (targetItem) {
					targetItem.classList.add('dl-show');
				}
			}
		}
	}

	updatePopupFirstThumbnail(gallery, variantId) {
		// 查找弹窗缩略图容器
		const thumbnailContainer = gallery.querySelector('.dl-product-gallery-pop-x-desktop-thumbnails');
		if (!thumbnailContainer) return;

		// 查找第一个缩略图
		const firstThumbnail = thumbnailContainer.querySelector('.dl-thumbnail-first-item');
		if (!firstThumbnail) return;

		// 查找弹窗首图容器，确认有变体首图（说明没有3D模型）
		const popupFirstItem = gallery.querySelector('.dl-product-gallery-pop-x-media-first-item');
		if (!popupFirstItem) return;

		const featuredItems = popupFirstItem.querySelectorAll('.dl-variant-featured-item');
		if (featuredItems.length === 0) return; // 没有变体首图，说明有3D模型，不需要更新

		// 找到目标变体的首图
		const targetItem = popupFirstItem.querySelector(`.dl-variant-featured-item[data-dl-variant-id="${variantId}"]`);
		if (!targetItem) return;

		// 获取目标图片的src
		const targetImg = targetItem.tagName === 'IMG' ? targetItem : targetItem.querySelector('img');
		if (!targetImg) return;

		// 更新缩略图的src
		const thumbnailImg = firstThumbnail.querySelector('img');
		if (thumbnailImg) {
			// 将大图URL转换为缩略图URL（width=160）
			const thumbnailSrc = targetImg.src.replace(/width=\d+/, 'width=160');
			thumbnailImg.src = thumbnailSrc;
		}
	}

	calculatePopupIndex(desktopContainer, clickedItem, gallery) {
		// 获取外面画廊中点击item的类型和位置信息
		const mediaType = clickedItem.dataset.mediaType;
		const imageIndex = clickedItem.dataset.imageIndex;
		
		// 检查弹窗中是否有3D模型（通过检查是否有变体首图）
		const popupFirstItem = gallery.querySelector('.dl-product-gallery-pop-x-media-first-item');
		const hasVariantFeaturedImage = popupFirstItem && popupFirstItem.querySelectorAll('.dl-variant-featured-item').length > 0;
		
		// 检查是否有视频
		const hasVideo = desktopContainer.querySelector('[data-media-type="video"]') !== null;
		
		// 情况1：点击的是首图
		if (mediaType === 'featured-image') {
			return 0; // 弹窗中首图始终是第0个（无论是变体首图还是3D模型）
		}
		
		// 情况2：点击的是视频
		if (mediaType === 'video') {
			// 弹窗中视频位置：无3D模型时在变体首图后（索引1），有3D模型时也在3D模型后（索引1）
			return 1;
		}
		
		// 情况3：点击的是普通图片
		if (mediaType === 'image' && imageIndex) {
			const imgIndex = parseInt(imageIndex);
			
			if (hasVariantFeaturedImage) {
				// 无3D模型：弹窗顺序 = 变体首图(0) + 视频(1,如有) + 第1张图(1或2) + 第2张图(2或3) + ...
				// 弹窗索引 = (有视频?1:0) + imgIndex
				return (hasVideo ? 1 : 0) + imgIndex;
			} else {
				// 有3D模型：弹窗顺序 = 3D模型(0) + 视频(1,如有) + 第2张图(1或2) + 第3张图(2或3) + ...
				// 注意：第一张图被跳过
				if (imgIndex === 1) {
					// 第一张图片在有3D模型时被跳过，点击它应该定位到3D模型
					return 0;
				}
				// 弹窗索引 = (有视频?1:0) + (imgIndex - 1)
				return (hasVideo ? 1 : 0) + (imgIndex - 1);
			}
		}
		
		// 默认返回0
		return 0;
	}

	bindEvents() {
		window.addEventListener('resize', this.onResize.bind(this));
		window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
		this.addEventListener('scroll', this.onGalleryScroll.bind(this), { passive: true });

		this.variantGalleries.forEach(vg => {
			vg.addEventListener('click', e => {
				const btn3d = e.target.closest('.dl-product-gallery-x-3d-btn');
				const btnGallery = e.target.closest('.dl-product-gallery-x-gallery-btn');
				const popBtn = e.target.closest('.dl-product-gallery-x-3d-container') || e.target.closest('.dl-product-gallery-x-3d-model-btn');
				if (btn3d) this.toggle3DView(vg);
				if (btnGallery) this.showGallery(vg);
				if (popBtn) vg.querySelector('dl-product-gallery-model-pop-x')?.show();

				const slide = e.target.closest('.dl-product-gallery-x-main-item-video.glide__slide');
				if (slide && vg.contains(slide)) {
					const popX = vg.querySelector('dl-product-video-pop-x-mobile');
					if (popX) popX.show();
				}

				if (window.innerWidth <= 990) return;

				// 桌面端：点击左侧图片 item → 打开桌面弹窗并定位
				const item = e.target.closest('.dl-product-gallery-x-desktop-gallery-item');
				const desktopContainer = item?.closest('.dl-product-gallery-x-desktop-gallery-main');
				if (!item || !desktopContainer || !vg.contains(desktopContainer)) return;

				e.preventDefault();
				e.stopPropagation();

				this.collectEvent('pdp_gallery_item_click', item.dataset.productHandle, item.dataset.imageIndex, item.dataset.mediaType, item.querySelector('img, video source')?.src || '');

				// 只在当前 variant 容器中查找弹窗，避免找到其他变体的弹窗
				const desktopPop = vg.querySelector('dl-product-gallery-pop-x-desktop');
				if (!desktopPop || typeof desktopPop.show !== 'function') {
					console.warn('⚠️ 未找到桌面端弹窗');
					return;
				}

				desktopPop.hydrateContent?.();
				if (this.currentVariantId) this.toggleFeaturedImage(vg, this.currentVariantId);

				// 计算弹窗中的正确索引
				const popupIndex = this.calculatePopupIndex(desktopContainer, item, vg);

				// 关键：在 show() 之前传入目标索引，弹层将用该索引直接初始化
				desktopPop.targetSlideIndex = popupIndex;
				desktopPop.show();
			});
		});

		this.addEventListener('click', async (e) => {
			const arButton = e.target.closest('.dl-product-gallery-ar-pop-x-enter');
			if (arButton && this.contains(arButton)) {
				e.stopPropagation();
				const visibleGallery = arButton.closest('.dl-product-gallery-x-container') || this.getVisibleGallery();
				if (!visibleGallery) {
					console.warn('⚠️ 未找到可见的画廊容器');
					return;
				}

				const arPopup = visibleGallery.querySelector('dl-product-gallery-ar-pop-x');
				if (arPopup && typeof arPopup.show === 'function') {
					const productHandle = arButton.dataset.productHandle;
					const productData = await DLPixelDataHelper.ProductHelper.getProductByHandle(productHandle);
					DLPixelH.capture('pdp_gallery_btn_click', {
						name: 'view_in_ar',
						...productData
					});
					arPopup.show();
				} else {
					console.warn('⚠️ 未找到AR弹窗');
				}
				return;
			}

			const appDemoButton = e.target.closest('.dl-product-gallery-app-demo-pop-m-enter');
			if (!appDemoButton || !this.contains(appDemoButton)) return;

			let link = appDemoButton.dataset.dlLink + '?source=dtc&site=' + DLPixelDataHelper.getStore();
			if (braze && braze.getDeviceId()) {
				link = link + '&ampDeviceId=' + braze.getDeviceId();
			}
			const urlObj = DLPixelDataHelper.URLHelper.getLandingPageInfo() || {};
			[
				['utmSource', 'utm_source'],
				['utmMedium', 'utm_medium'],
				['utmCampaign', 'utm_campaign'],
				['utmContent', 'utm_content'],
				['utmTerm', 'utm_term'],
			].forEach(([key, paramName]) => {
				if (urlObj[key]) {
					link += `&${paramName}=${encodeURIComponent(urlObj[key])}`;
				}
			});
			const productHandle = appDemoButton.dataset.productHandle;
			const productData = await DLPixelDataHelper.ProductHelper.getProductByHandle(productHandle);
			DLPixelH.capture('pdp_gallery_btn_click', {
				name: 'app_demo',
				...productData
			});
			window.location.href = link;
		});
	}

	async collectEvent(eventName, productHandle, imageIndex, mediaType, mediaSrc, source=undefined) {
		const productData = await DLPixelDataHelper.ProductHelper.getProductByHandle(productHandle);
		DLPixelH.capture(eventName, {
			...productData,
			galleryType: 'masonry',
			source,
			imageIndex,
			mediaType,
			mediaSrc: mediaSrc || ''
		});
	}


	onScroll() {

		if (window.innerWidth <= 990) {
			return;
		}
		if (this.isShortContentGallery) {
			this.checkSeeFullGalleryVisibility();
			return;
		}

		const announcementBar = document.querySelector('dl-announcement-bar-h');
		if (announcementBar) {
			if (window.scrollY > announcementBar.offsetHeight) {
				this.classList.add('dl-scroll');
				this.classList.add('dl-fixed');
			} else {
				this.classList.remove('dl-scroll');
				this.classList.remove('dl-fixed');
			}
		}
		this.isReachBottom();
		this.updateArButtonPosition();
		this.checkSeeFullGalleryVisibility();
	}

	onGalleryScroll() {
		if (window.innerWidth <= 990) return;
		this.checkSeeFullGalleryVisibility();
	}

	isReachBottom() {
		if (window.innerWidth <= 990) return;
		if (this.isShortContentGallery) {
			this.classList.remove('dl-scroll', 'dl-fixed', 'dl-reach-bottom');
			this.currentGalleryState = 'normal';
			return;
		}

		const rightContent = document.querySelector('.dl-product-h-main');
		if (!rightContent) return;

		const rightRect = rightContent.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		const addtoCartBarHeight = this.addtoCartBar?.offsetHeight || 0;
		const scrollY = window.scrollY || document.documentElement.scrollTop;

		const announcementBar = document.querySelector('dl-announcement-bar-h');
		const triggerHeight = announcementBar ? announcementBar.offsetHeight : 0;
		const hasPassedTrigger = scrollY > triggerHeight;

		const reachBottom = rightRect.bottom <= windowHeight - addtoCartBarHeight;

		let newState = 'normal';
		if (hasPassedTrigger) {
			newState = reachBottom ? 'dl-reach-bottom' : 'dl-fixed';
		}

		if (this.currentGalleryState !== newState) {
			this.classList.remove('dl-fixed', 'dl-reach-bottom');
			if (newState !== 'normal') this.classList.add(newState);
			this.currentGalleryState = newState;
		}
	}

	updateArButtonPosition() {
		if (window.innerWidth <= 990) return;
		const floatingButtons = this.getFloatingButtons();
		if (!floatingButtons.length) return;
		if (this.isShortContentGallery) {
			floatingButtons.forEach(button => {
				button.classList.remove('dl-ar-fixed', 'dl-ar-reach-bottom');
				button.style.removeProperty('--ar-button-bottom');
			});
			this.currentArButtonState = 'normal';
			return;
		}

		const rightContent = document.querySelector('.dl-product-h-main');
		if (!rightContent) return;

		const rightRect = rightContent.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		const addtoCartBarHeight = this.addtoCartBar?.offsetHeight || 0;
		const scrollY = window.scrollY || document.documentElement.scrollTop;

		const announcementBar = document.querySelector('dl-announcement-bar-h');
		const triggerHeight = announcementBar ? announcementBar.offsetHeight : 0;
		const hasPassedTrigger = scrollY > triggerHeight;

		const reachBottom = rightRect.bottom <= windowHeight - addtoCartBarHeight;

		let newState = 'normal';
		if (hasPassedTrigger) {
			newState = reachBottom ? 'dl-ar-reach-bottom' : 'dl-ar-fixed';
		}

		floatingButtons.forEach(button => {
			button.classList.remove('dl-ar-fixed', 'dl-ar-reach-bottom');
			if (newState !== 'normal') button.classList.add(newState);
		});
		this.currentArButtonState = newState;

		// 每次滚动都更新bottom值（不管状态是否改变）
		// 当到达底部时，动态计算AR按钮的bottom值（基于画廊底部）
		if (newState === 'dl-ar-reach-bottom') {
			// 计算画廊底部距离屏幕底部的距离，再加上想要的间距（40px）
			const galleryBottomDistance = windowHeight - rightRect.bottom;
			const arButtonBottom = galleryBottomDistance + addtoCartBarHeight + 80;
			floatingButtons.forEach(button => {
				button.style.setProperty('--ar-button-bottom', `${arButtonBottom}px`);
			});
		} else {
			// 非底部状态，移除CSS变量，使用默认值
			floatingButtons.forEach(button => {
				button.style.removeProperty('--ar-button-bottom');
			});
		}
	}

	checkSeeFullGalleryVisibility() {
		const floatingButtons = this.getFloatingButtons();
		if (!floatingButtons.length) return;
		if (window.innerWidth <= 990) {
			// 移动端不处理
			floatingButtons.forEach(button => button.classList.remove('dl-hidden'));
			return;
		}
	
		// 获取当前可见的画廊容器
		const visibleGallery = this.getVisibleGallery();
		
		if (!visibleGallery) return;
	
		// 获取 See full gallery 按钮
		const seeFullButton = visibleGallery.querySelector('.dl-product-gallery-pop-x-desktop-enter');
		if (!seeFullButton) {
			// 如果没有按钮，显示AR按钮
			floatingButtons.forEach(button => button.classList.remove('dl-hidden'));
			return;
		}
	
		// 检查按钮是否真实可见（display不为none等）
		if (seeFullButton.offsetParent === null) {
			floatingButtons.forEach(button => button.classList.remove('dl-hidden'));
			return;
		}
	
		// 获取画廊容器的可视区域（相对于画廊自身的滚动）
		const galleryRect = this.getBoundingClientRect();
		const buttonRect = seeFullButton.getBoundingClientRect();

		// 画廊底部有约 80px 会被固定元素挡住，进入这块区域不算真正可见
		const blockedBottom = 80;
		const viewportTop = 0;
		const viewportBottom = window.innerHeight - blockedBottom;
		const visibleTop = Math.max(galleryRect.top, viewportTop);
		const visibleBottom = Math.min(galleryRect.bottom, viewportBottom);

		let isVisibleInGallery = false;
		if (visibleBottom > visibleTop) {
			isVisibleInGallery =
				buttonRect.bottom > visibleTop &&
				buttonRect.top < visibleBottom;
		}
	
		if (isVisibleInGallery) {
			// See full gallery 按钮可见，隐藏 AR 按钮
			floatingButtons.forEach(button => button.classList.add('dl-hidden'));
		} else {
			// See full gallery 按钮不可见，显示 AR 按钮
			floatingButtons.forEach(button => button.classList.remove('dl-hidden'));
		}
	}

	onResize() {
		clearTimeout(this._resizeTimer);
		this._resizeTimer = setTimeout(() => {

			if (this.lastWindowWidth !== window.innerWidth) {
				const breakpoint = this.getCurrentBreakpoint();
				const visibleGallery = this.getVisibleGallery();
				if (breakpoint !== this.currentBreakpoint && visibleGallery) {
					this.hydrateGallery(visibleGallery, breakpoint);
					this.initializeGallery(visibleGallery, breakpoint);
					if (this.currentVariantId) this.toggleFeaturedImage(visibleGallery, this.currentVariantId);
					this.currentBreakpoint = breakpoint;
					this.currentArButtonState = null;
				}
				this.variantGalleries.forEach(vg => vg.glideInstance?.update());
				this.lastWindowWidth = window.innerWidth;
				this.observeShortContentLayout();
				this.isReachBottom();
				this.updateArButtonPosition();
				this.checkSeeFullGalleryVisibility();

				if (window.innerWidth <= 990) {
					this.classList.remove('dl-scroll', 'dl-fixed', 'dl-reach-bottom');
					this.getFloatingButtons().forEach(button => {
						button.classList.remove('dl-ar-fixed', 'dl-ar-reach-bottom');
					});
				}
			}
		}, 200);
	}

	initializeAllGalleries() {
		this.variantGalleries.forEach(vg => {
			this.initializeGallery(vg);
		});
		this.isReachBottom();
		this.updateArButtonPosition();
		this.checkSeeFullGalleryVisibility();
	}

	initGalleryVideoAutoplay(vg, breakpoint = this.getCurrentBreakpoint()) {
		const safePlay = (v) => {
			if (v.readyState === 0) {
				v.load();
				v.addEventListener('loadeddata', () => {
					v.loop = true;
					v.play().catch(() => {});
				}, { once: true });
			} else {
				v.loop = true;
				v.play().catch(() => {});
			}
		};

		// 桌面端：视频 item 进入视口时播放（group-x 结构下 desktop/mobile 分属不同 container）
		const videoItem = vg.querySelector('.dl-product-gallery-x-desktop-gallery-item[data-media-type="video"]');
		const video = videoItem?.querySelector('video');
		if (breakpoint === 'desktop' && videoItem && video && !videoItem._dlDesktopVideoAutoplayReady) {
			videoItem._dlDesktopVideoAutoplayReady = true;
			const obs = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						safePlay(video);
						obs.unobserve(videoItem);
					}
				});
			}, { rootMargin: '0px', threshold: 0.1 });
			obs.observe(videoItem);
		}

		// 移动端：Glide 切换到视频 slide 时播放（不依赖 desktop video 是否存在）
		const glideContainer = vg.querySelector('.dl-product-gallery-x-main');
		const mobileVideoSlide = vg.querySelector('.dl-product-gallery-x-main-item-video.glide__slide');
		const mobileVideo = mobileVideoSlide?.querySelector('video');
		if (breakpoint === 'mobile' && glideContainer && mobileVideoSlide && mobileVideo && vg.glideInstance && !mobileVideoSlide._dlMobileVideoAutoplayReady) {
			mobileVideoSlide._dlMobileVideoAutoplayReady = true;
			const slides = glideContainer.querySelectorAll('.glide__slide:not(.glide__slide--clone)');
			const videoSlideIndex = Array.from(slides).indexOf(mobileVideoSlide);
			if (videoSlideIndex >= 0) {
				const syncMobileVideo = () => {
					if (vg.glideInstance.index === videoSlideIndex) {
						safePlay(mobileVideo);
					} else if (!mobileVideo.paused) {
						mobileVideo.pause();
					}
				};
				vg.glideInstance.on('run.after', syncMobileVideo);
				syncMobileVideo();
			}
		}
	}

	initGlide(vg) {
		const container = vg.querySelector('.dl-product-gallery-x-main');
		if (!container) return;
		const slides = container.querySelectorAll('.glide__slide:not(.glide__slide--clone)');
		if (!slides.length) return;

		vg.slideCount = slides.length;
		vg.glideInstance?.destroy();

		const glide = new Glide(container, {
			type: 'carousel',
			perView: 1,
			gap: 0,
			startAt: 0,
			autoplay: false,
			hoverpause: true,
			keyboard: true,
			dragThreshold: 120,
			swipeThreshold: 120
		});

		glide.on('mount.after', () => this.updateCounter(vg));
		glide.on('run.after', () => this.updateCounter(vg));
		glide.mount();

		vg.glideInstance = glide;
		this.updateCounter(vg);

		// // ✅ 禁止 Glide 捕获 model-viewer 拖动（双重保险）
		// container.querySelectorAll('model-viewer').forEach(mv => {
		// 	mv.addEventListener('pointerdown', e => e.stopPropagation());
		// 	mv.addEventListener('mousedown', e => e.stopPropagation());
		// 	mv.addEventListener('touchstart', e => e.stopPropagation());
		// });
	}

	updateCounter(vg) {
		const counter = vg.querySelector('.dl-product-gallery-x-mobile-gallery-counter');
		if (!counter || !vg.glideInstance) return;
		const currentSpan = counter.querySelector('.dl-current-slide');
		const totalSpan = counter.querySelector('.dl-total-slides');
		if (!currentSpan || !totalSpan) return;

		currentSpan.textContent = vg.glideInstance.index + 1;
		totalSpan.textContent = vg.slideCount;
		const glideInstance = vg?.glideInstance;
		if (!glideInstance) return;
		
		const glideContainer = vg.querySelector('.dl-product-gallery-x-main');
		const currentItem = glideContainer?.querySelectorAll('.glide__slide:not(.glide__slide--clone)')[glideInstance.index];
		if (!currentItem) return;
		
		const { productHandle, source } = vg.dataset;
		const { mediaType } = currentItem.dataset;
		const mediaSrc = currentItem.querySelector('img, video source')?.src || '';
		const activeFeaturedImage = currentItem.querySelector('.dl-variant-featured-image.dl-show');
		const viewKey = `${glideInstance.index}:${activeFeaturedImage?.dataset.dlVariantId || ''}`;
		if (vg.dataset.lastTrackedViewX === viewKey) return;
		vg.dataset.lastTrackedViewX = viewKey;
		this.collectEvent('pdp_gallery_item_view', productHandle, glideInstance.index + 1, mediaType, mediaSrc, source);
	}

	toggle3DView(vg) {
		const container = vg.querySelector('.dl-product-gallery-x-mobile-gallery-container');
		const view3d = vg.querySelector('.dl-product-gallery-x-3d-view');
		vg.querySelector('.dl-product-gallery-x-3d-btn').classList.add('dl-selected');
		vg.querySelector('.dl-product-gallery-x-gallery-btn').classList.remove('dl-selected');
		if (!container || !view3d) return;

		container.classList.add('dl-slide-out-left');
		view3d.classList.add('dl-slide-in-left');
	}

	showGallery(vg) {
		const container = vg.querySelector('.dl-product-gallery-x-mobile-gallery-container');
		const view3d = vg.querySelector('.dl-product-gallery-x-3d-view');
		vg.querySelector('.dl-product-gallery-x-3d-btn').classList.remove('dl-selected');
		vg.querySelector('.dl-product-gallery-x-gallery-btn').classList.add('dl-selected');
		if (!container || !view3d) return;
		container.classList.remove('dl-slide-out-left');
		view3d.classList.remove('dl-slide-in-left');
	}

	// ==================== 自定义视频播放逻辑（支持多个视频） ====================
	initCustomVideoControls(vg) {
		const wrappers = vg.querySelectorAll('.dl-product-gallery-pop-x-media-item-video');

		if (!wrappers.length) return;

		wrappers.forEach(wrapper => {
			if (wrapper._dlCustomVideoReady) return;
			const video = wrapper.querySelector('video');
			const playBtn = wrapper.querySelector('.dl-product-gallery-pop-x-media-item-video-btn');
			if (!video || !playBtn) return;
			wrapper._dlCustomVideoReady = true;

			video.controls = false;
			playBtn.classList.add('dl-show');

			playBtn.addEventListener('click', () => {
				playBtn.classList.remove('dl-show');
				video.controls = true;
				if (video.readyState === 0) {
					video.load();
					video.addEventListener('loadeddata', () => video.play().catch(() => {}), { once: true });
				} else {
					video.play().catch(() => {});
				}
			});
		});

		// 在当前 variant 容器中查找移动端弹窗，而不是在整个 document 中查找
		const popX = vg.querySelector('dl-product-gallery-pop-x-mobile');
		if (popX && typeof popX.hide === 'function') {
			const originalHide = popX.hide.bind(popX);
			popX.hide = () => {
				wrappers.forEach(wrapper => {
					const video = wrapper.querySelector('video');
					const playBtn = wrapper.querySelector('.dl-product-gallery-pop-x-media-item-video-btn');
					if (!video) return;
					video.pause();
					video.currentTime = 0;
					video.controls = false;
					if (playBtn) playBtn.classList.add('dl-show');
				});
				originalHide();
			};
		}
	}
}

customElements.define('dl-product-gallery-x', DlProductGalleryX);

class DlProductGalleryXAppDemo extends HTMLElement {
	constructor() {
		super();
		this.button = this.querySelector('button');
		this.bindEvents();
	}
	bindEvents() {
		if (this.button) {
			this.button.addEventListener('click', async (e) => {
				let link = this.button.dataset.dlLink;
				const name = this.button.dataset.dlName;
				if (name === 'app_demo' && braze && braze.getDeviceId()) {
					link = link + '?source=dtc&ampDeviceId=' + braze.getDeviceId();
				}
				const productHandle = this.button.dataset.productHandle;
				const productData = await DLPixelDataHelper.ProductHelper.getProductByHandle(productHandle);
				DLPixelH.capture('pdp_gallery_btn_click', {
					name: name,
					...productData
				});
				window.location.href = link;
			});
		}
	}
}
if (!customElements.get('dl-product-gallery-x-app-demo')) {
	customElements.define('dl-product-gallery-x-app-demo', DlProductGalleryXAppDemo);
}

// ========== 通用弹窗基类扩展 ==========
class DlGalleryPopBase extends DlPopBaseH {
	toggleWrapperPosition(pos) {
		const wrapper = this.closest('.dl-product-gallery-x-mobile-gallery-wrapper');
		if (wrapper) wrapper.style.position = pos;
	}

	// 还原弹窗到原位置
	restoreToOriginal() {
		if (!this._originalParent) return;
		if (this._originalNext) this._originalParent.insertBefore(this, this._originalNext);
		else this._originalParent.appendChild(this);
	}
}

// 模型弹窗
class DlProductGalleryModelPopX extends DlGalleryPopBase {
	show() {
		this.toggleWrapperPosition('static');
		super.show();
		// 注入模型弹窗内的 model-viewer 自定义进度圈
		requestAnimationFrame(() => DlModelViewerHelper.initSpinner(this));
	}
	hide() {
		super.hide();
		this.toggleWrapperPosition('relative');
		this.restoreToOriginal();
	}
}
if (!customElements.get('dl-product-gallery-model-pop-x')) {
	customElements.define('dl-product-gallery-model-pop-x', DlProductGalleryModelPopX);
}

// 图片弹窗（移动端）
// class DlProductGalleryPopXMobile extends DlGalleryPopBase {
// 	show() {
// 		this.toggleWrapperPosition('static');
// 		super.show();
// 		this.moveCloseButton();
// 		requestAnimationFrame(() => this.scrollToTargetSlide());
// 	}

// 	hide() {
// 		super.hide();
// 		this.toggleWrapperPosition('relative');
// 		this.restoreCloseButton();
// 		this.resetVideos();
// 		this.restoreToOriginal();
// 	}

// 	scrollToTargetSlide() {
// 		const index = this.targetSlideIndex;
// 		const container = this.querySelector(this.dataset.scrollContainer || '.dl-pop-overlay-h');
// 		const items = this.querySelectorAll('.dl-product-gallery-pop-x-media-item');
// 		if (!container || !items[index]) return;

// 		const target = items[index];
// 		container.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
// 	}

// 	moveCloseButton() {
// 		const btn = this.querySelector('.dl-pop-base-h-close');
// 		const base = this.querySelector('.dl-pop-base-h');
// 		if (!btn || !base) return;

// 		this._originalParent = btn.parentNode;
// 		this._originalNext = btn.nextSibling;
// 		base.appendChild(btn);
// 		Object.assign(btn.style, { position: 'absolute', zIndex: 1000000002 });
// 	}

// 	restoreCloseButton() {
// 		const btn = this.querySelector('.dl-pop-base-h-close');
// 		if (!btn || !this._originalParent) return;
// 		if (this._originalNext)
// 			this._originalParent.insertBefore(btn, this._originalNext);
// 		else
// 			this._originalParent.appendChild(btn);

// 		this._originalParent = this._originalNext = null;
// 	}

// 	resetVideos() {
// 		const wrappers = this.querySelectorAll('.dl-product-gallery-pop-x-media-item-video');
// 		wrappers.forEach(wrapper => {
// 			const video = wrapper.querySelector('video');
// 			const playBtn = wrapper.querySelector('.dl-product-gallery-pop-x-media-item-video-btn');
// 			if (!video) return;

// 			video.pause();
// 			video.currentTime = 0;
// 			video.controls = false;
// 			if (playBtn) playBtn.classList.add('dl-show');
// 		});
// 	}
// }
// if (!customElements.get('dl-product-gallery-pop-x-mobile')) {
// 	customElements.define('dl-product-gallery-pop-x-mobile', DlProductGalleryPopXMobile);
// }

// 视频弹窗（移动端）
class DlProductVideoPopXMobile extends DlGalleryPopBase {
	constructor() {
		super();
		this.video = null;
	}

	connectedCallback() {
		if (typeof super.connectedCallback === 'function') {
			super.connectedCallback();
		}
		this.video = this.querySelector('video');
		this.prepareVideo();
	}

	show() {
		this.toggleWrapperPosition('static');
		super.show();
		this.playVideo();
	}
	hide() {
		super.hide();
		this.toggleWrapperPosition('relative');
		this.resetVideo();
		this.restoreToOriginal();
	}

	prepareVideo() {
		if (!this.video) return;
		this.video.autoplay = false;
		this.video.removeAttribute('autoplay');
		this.video.pause();
		try {
			this.video.currentTime = 0;
		} catch (err) {
			// 某些浏览器在未加载完时无法设置 currentTime
		}
	}

	playVideo() {
		if (!this.video) return;
		const playPromise = this.video.play();
		if (playPromise && typeof playPromise.catch === 'function') {
			playPromise.catch(() => {});
		}
	}

	resetVideo() {
		if (!this.video) return;
		this.video.pause();
		try {
			this.video.currentTime = 0;
		} catch (err) {
			// ignore
		}
	}
}
if (!customElements.get('dl-product-video-pop-x-mobile')) {
	customElements.define('dl-product-video-pop-x-mobile', DlProductVideoPopXMobile);
}

// 图片弹窗（桌面端）
class DlProductGalleryPopXDesktop extends DlGalleryPopBase {
	constructor() {
		super();
		this.glideInstance = null;
		this.thumbnailGlideInstance = null;
		this.eventListeners = []; // 预留：若需追踪事件监听器以便销毁
	}

	connectedCallback() {
		super.connectedCallback();
	}

	bindEvents() {
		if (this._dlPopupEventsBound) return;
		this._dlPopupEventsBound = true;
		const enter = this.querySelector('.dl-product-gallery-pop-x-desktop-enter');
		if (enter) {
			enter.addEventListener('click', () => {
				this.show();
			});
		}

		// 如果父类有 bindEvents，请在此调 super.bindEvents();
		if (typeof super.bindEvents === 'function') super.bindEvents();
	}

	hydrateContent() {
		if (this._dlPopupContentHydrated) return;
		const template = this.querySelector('template[data-dl-popup-template]');
		const content = this.querySelector('[data-dl-popup-content]');
		if (!template || !content) return;
		content.appendChild(template.content.cloneNode(true));
		template.remove();
		this._dlPopupContentHydrated = true;

		const hostGallery = this.closest('dl-product-gallery-x');
		const variantGallery = this.closest('.dl-product-gallery-x-container');
		if (hostGallery?.currentVariantId && variantGallery) {
			hostGallery.toggleFeaturedImage(variantGallery, hostGallery.currentVariantId);
		}
	}

	show() {
		this.hydrateContent();
		this._dlPopupPlayingVideo = null;
		this._dlPopupAnimating = true;
		this.toggleWrapperPosition('static');
		const hostGallery = this.closest('dl-product-gallery-x');
		if (hostGallery) hostGallery.style.zIndex = '100000000';
		super.show();
		requestAnimationFrame(() => {
			try {
				// 先注入自定义 model-viewer 进度圈，再初始化轮播（Glide 异常不应阻止已显示的遮罩）
				DlModelViewerHelper.initSpinner(this);
				this.bindModelViewerEvents();
				this.initGlide();
				// 弹窗 inner 有 0.3s translateY，等动画结束再播视频，避免 0×0 视口与多次 reset 闪屏
				const inner = this.querySelector('.dl-pop-base-h-inner');
				const onReady = () => {
					if (this._popupSyncFallback) {
						window.clearTimeout(this._popupSyncFallback);
						this._popupSyncFallback = null;
					}
					this._dlPopupAnimating = false;
					this.syncPopupVideos();
				};
				const onTransEnd = (e) => {
					if (e.propertyName !== 'transform') return;
					inner.removeEventListener('transitionend', onTransEnd);
					onReady();
				};
				if (inner) inner.addEventListener('transitionend', onTransEnd);
				this._popupSyncFallback = window.setTimeout(onReady, 350);
			} catch {
				// 初始化失败不应影响已显示的遮罩
			}
		});
	}

	bindModelViewerEvents() {
        const modelViewer = this.querySelector('model-viewer');
        if (!modelViewer) return;

        // 禁止画廊响应拖拽
        const disableGlide = () => this.glideInstance?.disable();
        const enableGlide = () => this.glideInstance?.enable();

        modelViewer.addEventListener('pointerdown', disableGlide, { passive: true });
        modelViewer.addEventListener('touchstart', disableGlide, { passive: true });
        modelViewer.addEventListener('pointerup', enableGlide, { passive: true });
        modelViewer.addEventListener('touchend', enableGlide, { passive: true });

        // 阻止滚动冒泡
        ['wheel', 'mousewheel'].forEach(evt => {
            modelViewer.addEventListener(evt, e => {
                e.stopPropagation();
                e.preventDefault();
            }, { passive: false });
        });
    }


	hide() {
		if (this._popupSyncFallback) {
			window.clearTimeout(this._popupSyncFallback);
			this._popupSyncFallback = null;
		}
		this._dlPopupPlayingVideo = null;
		this._dlPopupAnimating = false;
		this.pauseAllPopupVideos();
		super.hide();
		this.toggleWrapperPosition('relative');
		setTimeout(() => {
			const hostGallery = this.closest('dl-product-gallery-x');
			if (hostGallery) hostGallery.style.zIndex = 'auto';
			if (this.glideInstance) {
				this.glideInstance.destroy();
				this.glideInstance = null;
			}
			if (this.thumbnailGlideInstance) {
				this.thumbnailGlideInstance.destroy();
				this.thumbnailGlideInstance = null;
			}
		}, 300);
	}

	/** 与 Glide Html.slides 一致：track 下首个子节点（glide__slides）的直接子级，且排除 clone */
	getPopupMainSlides() {
		const root = this.querySelector('.dl-product-gallery-pop-x-desktop-main');
		if (!root) return [];
		const track = root.querySelector('[data-glide-el="track"]');
		const wrapper = track && track.children[0];
		if (!wrapper) return [];
		return [...wrapper.children].filter(
			(el) => el.nodeType === 1 && !el.classList.contains('glide__slide--clone')
		);
	}

	/** 等弹窗动画/布局完成后再走 load+play（避免 0×0 视口时 play 失败且 Promise 被吞） */
	waitPopupVideoLayoutThen(video, token, onReady) {
		let frames = 0;
		const maxFrames = 120;
		const tick = () => {
			if (video._dlPopupPlayToken !== token) return;
			const r = video.getBoundingClientRect();
			if (r.width >= 2 && r.height >= 2) {
				onReady();
				return;
			}
			if (frames++ >= maxFrames) {
				onReady();
				return;
			}
			requestAnimationFrame(tick);
		};
		requestAnimationFrame(tick);
	}

	/** 弹窗内主图区视频：HTML 为 autoplay:false + preload:metadata，打开/切 slide 时由 JS 播放 */
	safePlayPopupVideo(video) {
		if (!video) return;
		// 新一轮播放请求，作废上一轮延迟重试（避免切 slide 后旧定时器误播）
		const token = (video._dlPopupPlayToken = (video._dlPopupPlayToken || 0) + 1);

		video.muted = true;
		video.defaultMuted = true;
		video.playsInline = true;
		video.setAttribute('muted', '');
		video.setAttribute('playsinline', '');

		const startLoadAndPlay = () => {
			if (video._dlPopupPlayToken !== token) return;

			const tryPlay = () => {
				if (video._dlPopupPlayToken !== token) return;
				video.loop = true;
				const p = video.play();
				if (p && typeof p.catch === 'function') p.catch(() => {});
			};

			if (video.readyState >= 2) {
				tryPlay();
				return;
			}

			const onEnoughData = () => {
				if (video._dlPopupPlayToken !== token) return;
				tryPlay();
			};
			video.addEventListener('canplay', onEnoughData, { once: true });
			video.addEventListener('loadeddata', onEnoughData, { once: true });

			if (video.readyState === 0) video.load();
			tryPlay();

			video._dlPopupRetryTimer = window.setTimeout(() => {
				if (video._dlPopupPlayToken !== token) return;
				if (video.paused) tryPlay();
			}, 200);
		};

		this.waitPopupVideoLayoutThen(video, token, startLoadAndPlay);
	}

	getActivePopupVideoSlide() {
		const mainRoot = this.querySelector('.dl-product-gallery-pop-x-desktop-main');
		if (!mainRoot) return { wrapper: null, video: null };

		const activeSlide = mainRoot.querySelector(
			'.glide__slide.glide__slide--active:not(.glide__slide--clone)'
		);
		if (!activeSlide) return { wrapper: null, video: null };

		const wrapper = activeSlide.matches('.dl-product-gallery-pop-x-media-item-video')
			? activeSlide
			: activeSlide.querySelector('.dl-product-gallery-pop-x-media-item-video');
		if (!wrapper) return { wrapper: null, video: null };

		const video =
			Array.from(wrapper.querySelectorAll('video')).find((v) => !v.classList.contains('hidden')) ||
			wrapper.querySelector('video');
		return { wrapper, video };
	}

	pauseAllPopupVideos() {
		this.querySelectorAll('.dl-product-gallery-pop-x-media-item-video video').forEach((v) => {
			if (!v.paused) v.pause();
			if (v.readyState > 0) {
				try {
					v.currentTime = 0;
				} catch (e) {
					// ignore
				}
			}
		});
	}

	syncPopupVideos() {
		if (this._dlPopupAnimating) return;

		const mainRoot = this.querySelector('.dl-product-gallery-pop-x-desktop-main');
		if (!mainRoot) return;

		const { video: activeVideo } = this.getActivePopupVideoSlide();

		mainRoot.querySelectorAll('.dl-product-gallery-pop-x-media-item-video video').forEach((v) => {
			if (v === activeVideo) return;
			if (v._dlPopupRetryTimer) {
				window.clearTimeout(v._dlPopupRetryTimer);
				v._dlPopupRetryTimer = null;
			}
			if (!v.paused) v.pause();
			if (v.readyState > 0) {
				try {
					v.currentTime = 0;
				} catch (e) {
					// ignore
				}
			}
		});

		if (!activeVideo) {
			this._dlPopupPlayingVideo = null;
			return;
		}

		if (
			this._dlPopupPlayingVideo === activeVideo &&
			!activeVideo.paused &&
			!activeVideo.ended
		) {
			return;
		}

		this._dlPopupPlayingVideo = activeVideo;
		this.safePlayPopupVideo(activeVideo);
	}

	initGlide() {
		const glideContainer = this.querySelector('.dl-product-gallery-pop-x-desktop-main');
		const thumbnailContainer = this.querySelector('.dl-product-gallery-pop-x-desktop-thumbnails');

		if (!glideContainer || typeof Glide === 'undefined') return;

		if (this.glideInstance) {
			this.glideInstance.destroy();
		}

		const initialIndex = Math.max(0, Number(this.targetSlideIndex) || 0);

		this.glideInstance = new Glide(glideContainer, {
			type: 'carousel',
			perView: 1,
			gap: 0,
			startAt: initialIndex,
			autoplay: false,
			hoverpause: true,
			keyboard: true,
			dragThreshold: 120,
			swipeThreshold: 120
		});

		if (thumbnailContainer) {
			this.initThumbnailGlide(thumbnailContainer, initialIndex);
		}

		this.glideInstance.on('run.after', () => this.syncPopupVideos());

		this.glideInstance.mount();

		const slidesLen = this.getPopupMainSlides().length;
		const safeIdx =
			slidesLen > 0 ? Math.min(initialIndex, Math.max(0, slidesLen - 1)) : 0;
		const scheduleGo =
			typeof queueMicrotask === 'function'
				? (fn) => queueMicrotask(fn)
				: (fn) => setTimeout(fn, 0);
		scheduleGo(() => {
			if (!this.glideInstance) return;
			try {
				this.glideInstance.go(`=${safeIdx}`);
			} catch {
				// ignore
			}
		});

		// 保险：主画廊挂载后立即同步一次缩略图状态与位置
		if (thumbnailContainer) {
			const idx = Number(this.glideInstance.index);
			const thumbnailItems = thumbnailContainer.querySelectorAll('.dl-thumbnail-item');
			thumbnailItems.forEach(thumb => thumb.classList.remove('dl-selected'));
			const thumbMax = Math.max(0, thumbnailItems.length - 1);
			const safeThumb = Number.isFinite(idx) ? Math.min(Math.max(0, idx), thumbMax) : 0;
			if (thumbnailItems[safeThumb]) {
				thumbnailItems[safeThumb].classList.add('dl-selected');
				try {
					this.thumbnailGlideInstance?.go(`=${safeThumb}`);
				} catch {
					// ignore
				}
			}
		}
	}

	initThumbnailGlide(thumbnailContainer, initialIndex = 0) {
		const thumbnailGlideElement = thumbnailContainer.querySelector('.dl-product-gallery-pop-x-desktop-thumbnails-main');
		if (!thumbnailGlideElement) return;

		const thumbnailGlide = new Glide(thumbnailGlideElement, {
			type: 'carousel',
			perView: 'auto',
			gap: 8,
			startAt: initialIndex,
			autoplay: false,
			hoverpause: true,
			keyboard: false,
			dragThreshold: 120,
			swipeThreshold: 120
		});

		thumbnailGlide.on('mount.after', () => {
			const thumbnailItems = thumbnailContainer.querySelectorAll('.dl-thumbnail-item');

			thumbnailItems.forEach((thumb, i) => {
				thumb.classList.toggle('dl-selected', i === initialIndex);
			});

			thumbnailGlide.go(`=${initialIndex}`);

			thumbnailItems.forEach((item, index) => {
				item.addEventListener('click', () => {
					thumbnailItems.forEach(thumb => thumb.classList.remove('dl-selected'));
					item.classList.add('dl-selected');
					this.glideInstance.go(`=${index}`);
				});
			});
		});

		this.glideInstance.on('run', () => {
			const idx = Number(this.glideInstance.index);
			const thumbnailItems = thumbnailContainer.querySelectorAll('.dl-thumbnail-item');
			const thumbMax = Math.max(0, thumbnailItems.length - 1);
			const safe = Number.isFinite(idx) ? Math.min(Math.max(0, idx), thumbMax) : 0;
			thumbnailItems.forEach(thumb => thumb.classList.remove('dl-selected'));
			const currentThumb = thumbnailItems[safe];
			if (currentThumb) currentThumb.classList.add('dl-selected');
			try {
				thumbnailGlide.go(`=${safe}`);
			} catch {
				// ignore
			}
		});

		thumbnailGlide.mount();
		this.thumbnailGlideInstance = thumbnailGlide;
	}
}
if (!customElements.get('dl-product-gallery-pop-x-desktop')) {
	customElements.define('dl-product-gallery-pop-x-desktop', DlProductGalleryPopXDesktop);
}

class DlProductGalleryArPopX extends DlPopBaseH {
	constructor() {
		super();
		this.QRCode = null;
	}
	connectedCallback() {
		super.connectedCallback();
		this.QRCode = this.querySelector('.dl-product-gallery-ar-pop-x-QR-code')?.dataset?.dlLink || null;
	}

	show() {
		if (!this._originalParent) {
			this._originalParent = this.parentNode;
			this._originalNextSibling = this.nextSibling;
		}

		const productH = document.querySelector('dl-product-h');
		if (productH) {
			productH.appendChild(this);
		}

		super.show();
	}

	hide() {
		if (this._originalParent) {
			if (this._originalNextSibling) {
				this._originalParent.insertBefore(this, this._originalNextSibling);
			} else {
				this._originalParent.appendChild(this);
			}

			this._originalParent = null;
			this._originalNextSibling = null;
		}

		super.hide();
	}
}
if (!customElements.get('dl-product-gallery-ar-pop-x')) {
	customElements.define('dl-product-gallery-ar-pop-x', DlProductGalleryArPopX);
}
